import {UserMetricInstance} from "../user/Metric/UserMetricInstance";
import {MetricAlarmStatusEnum} from "../notification/MetricAlarmStatusLite";
import {GatewayStatusEnum} from "../gateway/GatewayStatusEnum";
import {WeekCalendar} from "./WeekCalendar";

export class PartitionAlarm {

  id!: number;
  name!: string;
  path!: string;
  hasAlarms!: boolean;
  gateways?: GatewayAlarm[];
  metricInstanceAlarms?: MetricInstanceAlert[];

  constructor() {
    this.gateways = [];
    this.metricInstanceAlarms = [];
  }

}

export class GatewayAlarm {
  id!: number;
  name!: string;
  alarmStatus!: number;
  status!: GatewayStatusEnum;
  devices!: DeviceAlarm[];
}


export class DeviceAlarm {
  id!: number;
  name!: string;
  alarmStatus!: number;
}

export class MetricInstanceAlert {

  id!: number;
  name!: string;
  enabled: boolean;
  beginAlarmNotificationOn: boolean;
  endAlarmNotificationOn: boolean;
  alarmType?: AlarmTypeEnum;
  additionalInfo?: MetricInstanceAlertEntityAdditionalInfo;
  metricInstance?: UserMetricInstance;
  alarmStatus?: MetricAlarmStatusEnum;
  alarmDetail?: Alarm;
  hasCalendar?: boolean;
  // Loaded/saved separately through getWeekCalendar/putWeekCalendar; null = always monitored
  calendar?: WeekCalendar | null;
  calendarForcedRecovery?: boolean;
  alarmCooldownSec?: number | null;

  constructor() {
    this.enabled = false;
    this.beginAlarmNotificationOn = false;
    this.endAlarmNotificationOn = false;
    this.alarmType = AlarmTypeEnum.THRESHOLD;
  }

}

export enum AlarmTypeEnum {
  THRESHOLD = 'THRESHOLD',
  STATIC = 'STATIC'
}

export class Alarm {
  beginDate?: number;
  endDate?: number;
  isInAlarmStatus?: boolean;
}

export class ContactDTO {
  value!: string;
  language!: string;
}

export class MetricInstanceAlertEntityAdditionalInfo {
  /**
   * Lista destinatari email
   */
  emailReceivers: ContactDTO[] = [];

  /**
   * Lista numeri di telefono destinatari WhatsApp
   */
  phoneReceivers: ContactDTO[] = [];

  /**
   * Definizione di allarme per metrica di numerico
   */
  numericAlarm?: NumericAlarm;

  /**
   * Definizione di allarme per metrica di Boolen
   */

  booleanAlarm?: BooleanAlarm;

  /**
   * Definizione di allarme per metrica di string
   */
  stringAlarm?: StringAlarm;

  /**
   * Definizione di allarme statico (misura stabile / misura che cambia)
   */
  staticAlarm?: StaticAlarm;
}

export class NumericAlarm {
  /**
   * Valore di soglia superiore
   */
  upperValue: number;
  upperLimitEnabled: boolean;
  /**
   * Valore di soglia inferiore
   */
  lowerValue: number;
  lowerLimitEnabled: boolean;

  constructor() {
    this.upperValue = 0;
    this.upperLimitEnabled = false;
    this.lowerValue = 0;
    this.lowerLimitEnabled = false
  }

}

export class BooleanAlarm {
  alarmValue: boolean;

  constructor() {
    this.alarmValue = true;
  }

}

export class StringAlarm {
  alarmValues: string[];

  constructor() {
    this.alarmValues = [];
  }

}

export class StaticAlarm {
  /**
   * true = allarme se la misura cambia; false = allarme se la misura resta stabile
   */
  alarmOnChange: boolean;
  /**
   * Minutaggio minimo fra le due letture confrontate, multiplo di STATIC_ALARM_SLOT_MINUTES
   */
  intervalMinutes: number;

  constructor() {
    this.alarmOnChange = false;
    this.intervalMinutes = STATIC_ALARM_SLOT_MINUTES;
  }

}

/**
 * Unità atomica del clock degli allarmi statici lato BE (alarm.static.slot-minutes)
 */
export const STATIC_ALARM_SLOT_MINUTES = 1;
